import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { ReactComponent as MenuIcon } from "../../assets/icons/menu-24px.svg";
import {
  CompanyFirstRow,
  CompanySecondRow,
  CompanyThirdRow,
  MainBottomMenu,
  Menu,
} from "../../Components/Main";
import { getUser, login, setToken } from "../../Redux/Actions/Authentication";
const Main = ({ deleteUser, deleteToken, logout, isLogin }) => {
  const [open, setopen] = useState(false);
  const history = useHistory();
  const standalone = window.matchMedia("(display-mode: standalone)").matches;
  useEffect(() => {
    if (standalone) {
      history.push("/addtohome");
    } else if (!isLogin) {
      history.push("/login");
    }
  }, []);

  useEffect(() => {
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    (window.orientation == 90 || window.orientation == -90) &&
      isMobile &&
      history.push("/rotate");
    window.addEventListener(
      "orientationchange",
      function () {
        var isForbidden =
          (window.orientation == 90 || window.orientation == -90) && isMobile;
        if (isForbidden) {
          history.push("/rotate");
        }
      },
      false
    );
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  useEffect(() => {
    !window.navigator.onLine && toast.warn("دستگاه به اینترنت متصل نیست");
  }, [window.navigator.onLine]);
  return (
    <div className="Container" id="Container">
      <div className="mobileContainer" style={{ overflowY: "scroll" }}>
        {/* <div className="mainPageHeader">
          <div>
          <img src={require("../../assets/images/Text.png")} />
          </div>
        </div> */}

        <img
          src={require("../../assets/images/MainHeader@3x.png")}
          className="MainBG"
        />
        <img
          src={require("../../assets/images/HomeLogo@3x.png")}
          className="MainBGIcon"
          id="loadImage"
        />

        <MenuIcon
          className={open ? "menuButtonOpen" : "menuButton"}
          onClick={() => setopen(!open)}
        />
        <CompanyFirstRow />
        <CompanySecondRow />
        <CompanyThirdRow />

        {/* <BottomDarkBlue /> */}
        <MainBottomMenu />
        <Menu
          open={open}
          deleteUser={deleteUser}
          setOpen={setopen}
          deleteToken={deleteToken}
          logout={logout}
        />
      </div>
    </div>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    deleteUser: () => dispatch(getUser([])),
    deleteToken: () => dispatch(setToken()),
    logout: () => dispatch(login(false)),
  };
};
const mapStateToProps = (state) => {
  return {
    isLogin: state.auth.isLogin,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Main);
